import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@michelin/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardReturnBack implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.role === 'Admin') {
      return true;
    } else {
      this.router.navigate(['/request']);
      return false;
    }
  }
}
